// Créneaux de 15 min, 07:00 à 16:45 — grille standard du planning atelier/réception.
export const HEURES = Array.from({ length: 40 }, (_, i) => {
  const h = Math.floor(i / 4) + 7;
  const m = (i % 4) * 15;
  return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
});

// Extrait la partie calendaire « YYYY-MM-DD » d'une date pure, quelle que soit sa
// forme (chaîne 'YYYY-MM-DD', ISO 'YYYY-MM-DDThh:mm:ssZ', ou objet Date). Ne passe
// JAMAIS par un fuseau : on ne veut pas décaler une date sans notion d'heure.
export const toYmd = (value) => {
  if (!value) return '';
  if (value instanceof Date) {
    return `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, '0')}-${String(value.getDate()).padStart(2, '0')}`;
  }
  return String(value).slice(0, 10);
};

// Convertit une date pure en objet Date positionné à MINUIT LOCAL.
//
// C'est LE remède au décalage de fuseau qui revient sans cesse : `new Date('2026-09-15')`
// est spécifié comme minuit UTC, soit le 14 septembre à 20 h aux Antilles. Tout ce qu'on
// en tire derrière est alors faux d'un jour — un libellé affiché (J-1), mais aussi un
// `getDay()`, ce qui est pire : le lundi devient dimanche et une recherche de pauses par
// jour de semaine ne trouve plus rien.
//
// Toute date SANS heure venant de l'API (colonnes PostgreSQL `date`) doit passer par ici
// avant d'être manipulée comme un objet Date.
export const dateLocale = (value) => {
  const [a, m, j] = toYmd(value).split('-').map(Number);
  if ([a, m, j].some((n) => Number.isNaN(n))) return null;
  return new Date(a, m - 1, j);
};

// Formate une date pure en libellé FR SANS décalage de fuseau : on reconstruit la
// date en heure locale (new Date(y, m-1, d)) au lieu de laisser `new Date('YYYY-MM-DD')`
// l'interpréter en UTC (ce qui recule d'un jour dans les fuseaux à l'ouest de Greenwich).
export const formatDateFr = (value, opts = { day: '2-digit', month: '2-digit', year: 'numeric' }) => {
  const d = dateLocale(value);
  return d ? d.toLocaleDateString('fr-FR', opts) : '—';
};

// Décale une date pure de n jours, en heure LOCALE. Même piège que ci-dessus, en
// pire : `new Date('2026-08-10')` donne minuit UTC, soit le 9 août à 20 h aux
// Antilles ; y ajouter un jour puis relire les champs locaux (ce que fait toYmd)
// ramène au 10 août — le « lendemain » retombait sur le jour même. Invisible en
// Europe, systématique en Guadeloupe et en Martinique.
export const ajouterJours = (value, n) => {
  const d = dateLocale(value);
  if (!d) return null;
  d.setDate(d.getDate() + n);
  return d;
};

// Lendemain ouvré : on saute le dimanche, seul jour de fermeture commun aux ateliers.
export const jourSuivantOuvre = (value) => {
  const d = ajouterJours(value, 1);
  if (!d) return null;
  if (d.getDay() === 0) d.setDate(d.getDate() + 1);
  return d;
};
